import { MutationTree } from 'vuex';
import { AuthState } from '@/store/types';
import { SexTypes, UserTypes } from "@/types/abstract";

const mutations: MutationTree<AuthState> = {
    registerUserInfo(state, user) {
        state.uid = user.uid;
        state.phoneNumber = user.phoneNumber;
        state.userType = user.userType;
        state.sex = user.sex;
    },
    setUid(state,uid){
        state.uid = uid;
    },
    clearUserInfo(state) {
        state.uid = '';
        state.phoneNumber = '';
        state.userType = UserTypes.None;
        state.sex = SexTypes.None;
    }
};

export default mutations;